import {  GET_PAYMENT_MODE_OPT } from "../../../config/realstar-api-config";
import axios from "../../axios/axios";

export const fetchPaymentModeOpt = async () => {

  try {
    const response = await axios.get(`${GET_PAYMENT_MODE_OPT}`);
    
    if(response.status === 200)
    { return response?.data }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching gst data:', error);
    throw error;
  }
};